export enum ExamStatus
{
    NotStarted,
    HasUnansweredQuestions,
    AllQuestionsAnswered,
    Passed,
    Failed,
    Cancelled,
}